// @ts-nocheck
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import React, { FC } from "react";

/* Store Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";
/* Store Custom Code - End */

export interface BreadcrumbStyles {
    /* Store Custom Code - Start */
    wrapper?: InjectableCss;
    content?: InjectableCss;
    /* Store Custom Code - End */
}

export const breadcrumbStyles: BreadcrumbStyles = {
    /* Store Custom Code - Start */
    wrapper: {
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
            padding: 1em 0;

            @media print {
                display: none;
            }
        `,
    },
    content: {
        css: css`
            ${siteWidthStyles()}
        `,
    },
    /* Store Custom Code - End */
};

const styles = breadcrumbStyles;

const Breadcrumbs: FC<WidgetProps> = () => (
    /* Store Custom Code - Start */
    <StyledWrapper {...styles.wrapper}>
        <StyledWrapper {...styles.content}>
            <PageBreadcrumbs />
        </StyledWrapper>
    </StyledWrapper>
    /* Store Custom Code - End */
);

const definition: WidgetDefinition = {
    group: "Common",
    displayName: "Breadcrumbs",
    icon: "ellipsis-stroke",
};

const widgetModule: WidgetModule = {
    component: Breadcrumbs,
    definition,
};

export default widgetModule;
